export default "__VITE_ASSET__CbVju2fG__"